<template>
  <!-- 外部ユーザー検索 -->
  <div id="ExternalUserSearch">
    <div id="container">
      <masterNavi v-bind:pageid='"UserManage"'></masterNavi>
      <div class="labelTitle lable">ユーザー管理</div>
      <userNavi v-bind:pageid='"ExternalUserSearch"'></userNavi>
      <div class="labelTitle lable">外部ユーザー検索</div>
      <!--検索条件 -->
      <externalUserSearch v-bind:preSearchConditions="searchConditions"/>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/master/MasterMaintenanceBar";
import userNaviBar from "@/components/mock/philips/master/user/UserNavi";
import externalUserSearchTemplate from "@/components/mock/philips/master/user/ExternalUserSearchContent";
export default {
  name: "ExternalUserSearch",
  methods: {
  },
  data() {
    var searchConditions = this.$route.params["searchConditions"];
    return {
      searchConditions:searchConditions
    };
  },
  filters: {},
  components: {
    masterNavi: naviBar,
    userNavi: userNaviBar,
    externalUserSearch: externalUserSearchTemplate
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width: 100px;
}


</style>


// WEBPACK FOOTER //
// src/components/mock/philips/master/user/ExternalUserSearch.vue